<div class="form-group">
    <div class="d-flex align-items-center h20">
        <label *ngIf="label !== ''" class="lh15 pb-1">{{label}}
            <span class="text-danger" *ngIf="mandatory">*</span>
        </label>
        <div class="ml-auto text-danger lh15 pb-1" *ngIf="errorText !== '' && value !== ''">
            <small>{{errorText}}</small>
        </div>
        <div class="ml-auto text-danger lh15 pb-1" *ngIf="value === '' && errorTrueNow && mandatory">
            <small>mandatory</small>
        </div>
    </div>
    <div class="input-group">
        <input autocomplete="none" type="text" class="form-control" [(ngModel)]="value" name="{{name}}"
            placeholder="{{placeholder}}" [ngClass]="{'border-warn': value === '' && errorTrueNow}"
            [disabled]="btnClickedNow" (blur)="blured()" #inputbox (keydown)="checkenter($event)" appNumberOnly
            [limit]="limit" [decimal]="decimal" [max]="max">
        <div class="input-group-append in-1" *ngIf="value && !btnClickedNow">
            <a mat-button class="i-btn" (click)="doClear()" matTooltip="Clear" matTooltipPosition="right" tabIndex="-1">
                <ion-icon name="close-outline"></ion-icon>
            </a>
        </div>
    </div>
    <!-- <div class="input-group">
        <input autocomplete="none" type="text" class="form-control" [(ngModel)]="value" name="{{name}}"
            placeholder="{{placeholder}}" [ngClass]="{'border-warn': errorTrueNow}"
            [disabled]="btnClickedNow" (blur)="blured()" #inputbox (keydown)="checkenter($event)" appNumberOnly [limit]="limit" [decimal]="decimal" [max]="max">
        <div class="input-group-append in-1" *ngIf="value && !btnClickedNow">
            <a mat-button class="i-btn" (click)="value = ''" matTooltip="Clear" matTooltipPosition="right"
                tabIndex="-1">
                <ion-icon name="close-outline"></ion-icon>
            </a>
        </div>
    </div> -->
</div>